import { combineReducers } from '@ynap/reducer-utils'
import * as reducers from './reducers/index'

const orderHistoryReducer = combineReducers(reducers)

export default orderHistoryReducer
